import React, { ReactElement } from 'react';
import { IconProps } from '../../../features';

export const AllSpheresIconComponent = ({
  width = 24,
  height = 24,
  strokeColor = '#78747A',
}: IconProps): ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
  >
    <path
      stroke={strokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="2"
      d="M5.182 3h13.636C20.023 3 21 3.977 21 5.182v13.636A2.182 2.182 0 0 1 18.818 21H5.182A2.182 2.182 0 0 1 3 18.818V5.182C3 3.977 3.977 3 5.182 3ZM12 20.727V3.273M20.727 12H3.273"
    />
  </svg>
);
